<app-change-password [formGroup]="formGroup" *transloco="let t">
  <app-epson-logo image></app-epson-logo>
  <app-header divider>
    {{ t('create-new-password') }}
  </app-header>
  <app-paragraph text>
    {{ t('create-new-password-informative-text-1') }}
  </app-paragraph>
  <app-input id="create-new-password-page-password-input"
             input
             [control]="getControl('password')"
             required
             type="password"
             [label]="t('password')">
  </app-input>
  <app-form-feedback-list form-feedback
                          [abstractControl]="formGroup.get('password')">
  </app-form-feedback-list>
  <app-input id="create-new-password-page-confirm-password-input"
             input
             [control]="getControl('confirmPassword')"
             required
             type="password"
             [label]="t('confirm-password')">
  </app-input>
  <app-input id="create-new-password-page-code-input"
             input
             [control]="getControl('code')"
             required
             [label]="t('code')">
  </app-input>
  <app-label id="create-new-password-page-error-message" error-message *ngIf="errorMessage" isError>
    {{ errorMessage }}
  </app-label>
  <app-recaptcha *ngIf="recaptchaEnabled"
                 id="recaptcha-login-forgot"
                 [formGroup]="formGroup"
                 abstractFormControlName="recaptcha"
                 recaptcha
                 #captchaRef>
  </app-recaptcha>
  <app-paragraph disclaimer-text>
    <ul>
      <li>{{ t('create-new-password-informative-text-2') }}
        <app-anchor id="forgot-password-page-recover-password-click"
          (click)="resendEmail()"
          secondInputSubscript>
    {{ t('create-new-password-informative-text-3') }}
    </app-anchor>
 {{ t('create-new-password-informative-text-4') }}</li>
      <li>{{ t('create-new-password-informative-text-5') }}</li>
      <li>{{ t('create-new-password-informative-text-6') }}
        <app-anchor id="login-page-forgot-password-click"
          secondInputSubscript
          (click)="navigateToFAQPage()">
          {{ t('create-new-password-informative-text-7') }}
        </app-anchor>
        {{ t('create-new-password-informative-text-8') }}</li>
    </ul>
  </app-paragraph>
  <app-primary-button id="create-new-password-page-reset-password-click"
                      button
                      (clickAction)="resetPassword()"
                      [disabled]="isResetPasswordDisabled()">
    {{ t('create-password') }}
  </app-primary-button>
  <app-primary-button id="resend-code-forgot-password"
                      button
                      (clickAction)="resendEmail()"
                      type="button"
                      *transloco="let t"
                      [disabled]="resendLoading"
                      stroked>
    <div *ngIf="resendLoading" class="resend-loading">
      <mat-spinner diameter="15"></mat-spinner>
    </div>
    <ng-container *ngIf="!resendLoading">
      {{ t('resend-code-forgot-password') }}
    </ng-container>
  </app-primary-button>
</app-change-password>
